"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.primaryCategory = exports.ProductTypesEnum = void 0;
const i18n_1 = require("../common/i18n");
var ProductTypesEnum;
(function (ProductTypesEnum) {
    ProductTypesEnum["ACCESSORY"] = "accessory";
    ProductTypesEnum["FOOT_GAUGE"] = "foot-gauge";
    ProductTypesEnum["SHOE"] = "shoe";
    ProductTypesEnum["GIFT_CARD"] = "gift-card";
    ProductTypesEnum["EGIFT_CARD"] = "egift-card";
    ProductTypesEnum["SHOE_CARE"] = "shoe-care";
})(ProductTypesEnum || (exports.ProductTypesEnum = ProductTypesEnum = {}));
const primaryCategory = (primaryCategoryTypeId) => ({
    name: 'primaryCategories',
    type: {
        name: 'set',
        elementType: {
            name: 'nested',
            typeReference: {
                typeId: 'product-type',
                id: primaryCategoryTypeId,
            },
        },
    },
    label: (0, i18n_1.localizedString)('Primary Categories'),
    attributeConstraint: 'SameForAll',
    isSearchable: true,
    isRequired: false,
});
exports.primaryCategory = primaryCategory;
//# sourceMappingURL=common.js.map